const features = [
  {
    id: 1,
    title: '实时推送',
    desc: '7×24小时全天候监控全网热点，重大爆料事件5分钟内推送至全平台，让你永远快人一步吃到大瓜。',
    icon: 'ri-notification-3-line',
  },
  {
    id: 2,
    title: '多维度盘点',
    desc: '每起事件都提供完整时间线、相关人物关系图、证据链梳理和各方回应汇总，深度还原事件全貌。',
    icon: 'ri-stack-line',
  },
  {
    id: 3,
    title: '匿名保护',
    desc: '所有投稿和爆料人均享受严格匿名保护，平台采用多重加密技术，确保爆料人身份信息安全不泄露。',
    icon: 'ri-shield-user-line',
  },
  {
    id: 4,
    title: '多端同步',
    desc: '支持Web端、iOS、Android三端无缝同步，阅读进度、收藏内容自动云端同步，换设备也能接着吃瓜。',
    icon: 'ri-device-line',
  },
  {
    id: 5,
    title: '社区互动',
    desc: '千万瓜友实时互动，评论、点赞、分享一键完成。热门话题专属讨论区，和同好一起深度吃瓜。',
    icon: 'ri-group-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-2">为什么千万瓜友选择51每日大赛？</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200 rounded-xl p-5 transition-all duration-200 hover:border-accent-300 cursor-pointer group"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}